import React, { useState } from "react";
import { Sheet, SheetTrigger, SheetContent, SheetHeader, SheetTitle } from "..";
import { Button } from "../../button";
import { Notebook } from "lucide-react";
import { useTranslation } from "react-i18next";
import CommentsTable from "../../table/CommentsTable";
import SearchCommentsCard from "../../card/SearchCommentsCard";
import { PAGE_SIZE } from "../../../constants/common";

interface CommentsDrawerProps {
  noButtonStyles?: boolean;
}

const CommentsDrawer = ({ noButtonStyles = false }: CommentsDrawerProps) => {
  const [open, setOpen] = useState(false);

  const { t, i18n } = useTranslation();

  const [allComments, setAllComments] = useState([]);

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search] = useState("");

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        {!noButtonStyles ? (
          <Button
            onClick={() => setOpen(true)}
            className="flex max-w-max items-center gap-2"
          >
            <Notebook className="w-5" />
            <p className="text-sm">{t("viewComments")}</p>
          </Button>
        ) : (
          <div
            onClick={() => setOpen(true)}
            className="flex max-w-max items-center gap-2 border-b-2 border-purple-primary pb-1 cursor-pointer"
          >
            <Notebook className="w-5" />
            <p className="text-sm">{t("viewComments")}</p>
          </div>
        )}
      </SheetTrigger>

      <SheetContent side={i18n.language === "en" ? "right" : "left"}>
        <div className="p-2 sm:p-5 flex flex-col gap-4">
          <SheetHeader>
            <SheetTitle>{t("comments")}</SheetTitle>
          </SheetHeader>

          <div className="flex flex-col gap-4">
            <SearchCommentsCard
              setAllComments={setAllComments}
              page={page}
              setPages={setPages}
              search={search}
              setCount={setCount}
              pageSize={pageSize}
            />
            <CommentsTable
              comments={allComments}
              page={page}
              pages={pages}
              setPage={setPage}
              count={count}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />

            <Button className="max-w-max" onClick={() => setOpen(false)}>
              {t("close")}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default React.memo(CommentsDrawer);
